export default __webpack_public_path__ + "static/media/CruiseQueenImgThree.f3b85f29.png";